export default __webpack_public_path__ + "0a0eb7f9f7f78135c12119f0286e0719.png";